import React from 'react';
import { ChevronLeft, Mail, MessageSquare } from 'lucide-react';

interface ContactPageProps {
  onBack: () => void;
}

export const ContactPage: React.FC<ContactPageProps> = ({ onBack }) => {
  const CONTACT_EMAIL = 'vitacore.fit.wellness@gmail.com';

  return (
    <div className="p-4 md:p-8 pb-32 space-y-8 max-w-4xl mx-auto animate-fadeIn">
      <div className="flex items-center gap-4 mb-8">
        <button 
          onClick={onBack} 
          className="p-3 bg-slate-900 border border-slate-800 rounded-2xl hover:bg-slate-800 transition-colors"
        >
          <ChevronLeft size={24} />
        </button>
        <div className="flex items-center gap-3">
          <div className="p-3 bg-emerald-500/10 rounded-2xl text-emerald-400">
            <MessageSquare size={24} />
          </div>
          <div>
            <h1 className="text-2xl font-black italic tracking-tighter uppercase text-white">Contact Us</h1>
            <p className="text-slate-500 text-xs font-bold uppercase tracking-widest">Get in Touch</p>
          </div>
        </div>
      </div>

      <div className="bg-slate-900 border border-slate-800 rounded-[2.5rem] p-8 md:p-12 shadow-xl space-y-8">
        <section>
          <h2 className="text-xl font-black text-white mb-4 uppercase tracking-tight flex items-center gap-3">
            <Mail size={20} className="text-emerald-400" />
            Email Support
          </h2>
          <p className="text-slate-300 leading-relaxed mb-4">
            For any inquiries, support requests, or feedback, please contact us at:
          </p>
          <a 
            href={`mailto:${CONTACT_EMAIL}`}
            className="inline-flex items-center gap-3 px-6 py-4 bg-emerald-500/10 border border-emerald-500/30 rounded-2xl text-emerald-400 hover:bg-emerald-500/20 transition-all font-bold text-lg"
          >
            <Mail size={20} />
            {CONTACT_EMAIL}
          </a>
        </section>

        <section className="pt-6 border-t border-slate-800">
          <h2 className="text-xl font-black text-white mb-4 uppercase tracking-tight">Response Time</h2>
          <p className="text-slate-300 leading-relaxed">
            We aim to respond to all inquiries within 24-48 hours during business days. For urgent matters, please mark your email as "URGENT" in the subject line.
          </p>
        </section>

        <section className="pt-6 border-t border-slate-800">
          <h2 className="text-xl font-black text-white mb-4 uppercase tracking-tight">What We Can Help With</h2>
          <ul className="list-disc list-inside text-slate-300 space-y-2 ml-4">
            <li>Account and billing questions</li>
            <li>Technical support and troubleshooting</li>
            <li>Feature requests and feedback</li>
            <li>Refund and cancellation requests</li>
            <li>Privacy and data concerns</li>
            <li>Partnership and business inquiries</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

